<p-button
  [text]="true"
  [disabled]="isDisabled()"
  severity="contrast"
  styleClass="!h-7
    !px-1.5
    !py-1
    !gap-[0.25rem]
    !text-(--p-primary-500)
    hover:not-disabled:!bg-(--p-neutral-500)
    hover:not-disabled:!border-(--p-primary-100)"
  [pTooltip]="'@@floating-popup-histogram-export-csv' | translate"
  (click)="export.emit()"
  tooltipPosition="bottom"
  tooltipStyleClass="text-[0.75rem] !z-app-overlay-0">
  <svg-icon src="icons/icon-download.svg" class="text-(--p-primary-500)" name="icon-download"></svg-icon>

  @let isScreenMdUp = scrRes.isScreenMdUp();
  @let isLabelVisible = !isLabelHidden();

  @if (isScreenMdUp && isLabelVisible) {
    <span class="text-(--p-primary-500) text-[0.6875rem] font-medium leading-4 ml-1" translate="@@floating-popup-histogram-export-csv"></span>
  }
</p-button>